<template>
  <v-container>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card class="card--flex-toolbar">
          <v-toolbar card class="white" prominent>
            <v-toolbar-title class="body-4 primary--text">{{ $t("signup_form") }}</v-toolbar-title>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignup">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="hotel"
                      :label="$t('hotel_name')"
                      id="hotel"
                      v-model="hotel"
                      :rules="[() => !!hotel || $t('required_field')]"
                      required
                      autofocus></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="hotel_url"
                      :label="$t('hotel_url')"
                      id="hotel_url"
                      v-model="hotel_url"
                      :rules="[() => !!hotel_url || $t('required_field')]"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="hotel_person"
                      :label="$t('hotel_person')"
                      id="hotel_person"
                      v-model="hotel_person"
                      :rules="[() => !!hotel_person || $t('required_field')]"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="hotel_city"
                      :label="$t('city')"
                      id="hotel_city"
                      v-model="hotel_city"
                      :rules="[() => !!hotel_city || $t('required_field')]"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <CountrySelect :country.sync="hotel_country"></CountrySelect>
                  </v-flex>
                </v-layout>

                <v-layout row class="mt-4">
                  <v-flex xs12>
                    <v-text-field
                      name="email"
                      :label="$t('email')"
                      id="email"
                      v-model="email"
                      type="email"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="password"
                      :label="$t('password')"
                      id="password"
                      v-model="password"
                      type="password"
                      :rules="[() => password.length >= 5 || $t('enter_at_least_5_characters')]"
                      required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="confirmPassword"
                      :label="$t('password_confirm')"
                      id="confirmPassword"
                      v-model="confirmPassword"
                      type="password"
                      :rules="[comparePasswords]"></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs1>
                    <v-checkbox
                      v-model="licence_agree"
                      color="primary"
                    >
                    </v-checkbox>
                  </v-flex>
                  <v-flex xs11 class="compress_lines grey--text lighten-2" @click.stop="showTacDialog = true">
                    <tac-dialog :showDialog="showTacDialog" @closeDialog="showTacDialog = false"></tac-dialog>
                    <b>{{ $t("user_licence_agree") }}</b>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12 class="text-xs-center">
                    <v-btn type="submit" :disabled="loading" :loading="loading">
                      {{ $t("signup") }}
                      <span slot="loader" class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CountrySelect from '../components/CountrySelect'
import TacDialog from '../components/TacDialog'
import { HTTP, showError } from '../../utils'

export default {
  components: {
    CountrySelect,
    'tac-dialog': TacDialog
  },

  data () {
    return {
      hotel: '',
      hotel_person: '',
      hotel_url: '',
      hotel_city: '',
      hotel_country: '',
      email: '',
      password: '',
      confirmPassword: '',

      loading: false,
      licence_agree: false,
      showTacDialog: false
    }
  },

  computed: {
    comparePasswords () {
      return this.password !== this.confirmPassword ? this.$t('password_match') : ''
    }
  },

  methods: {
    onSignup () {
      const self = this

      // Souhlas s licenci, pokud zakladam novou registraci.
      if (!this.licence_agree) {
        showError(self, this.$t('add_user_licence_agree'))
        return
      }

      // Musi byt vyplneny povinne udaje.
      if (this.hotel_country === '') {
        this.$swal({
          title: this.$t('warning'),
          text: this.$t('field_country_mandatory'),
          type: 'warning'
        })
        return
      }

      // Save hotel information.
      const user = {
        email: this.email,
        password: this.password,
        hotel: this.hotel,
        hotel_person: this.hotel_person,
        hotel_url: this.hotel_url,
        hotel_city: this.hotel_city,
        hotel_country: this.hotel_country
      }

      this.loading = true

      HTTP.post('signup', user)
        .then(response => {
          this.loading = false
          const data = response.data
          if (data.status < 0) {
            console.log('Signup error: ' + data.message)
            showError(self, data.message)
          } else {
            this.$router.push('/signup-confirm')
          }
        })
        .catch(error => {
          console.log('SignUp error: ' + error.message)
          this.loading = false
          showError(self, error.message)
        })
    }
  }
}
</script>

<style scoped>
.compress_lines {
  margin: 0;
  padding: 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/User/Signup.vue